import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect } from 'react';

export const useScrollLockOnMobile = (isEnabled: boolean) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  const applyDocumentBodyStyle = (overflowCSS = '', touchActionCSS = '') => {
    document.body.style.overflow = overflowCSS;
    document.body.style.touchAction = touchActionCSS;
  };

  useEffect(() => {
    if (isEnabled && isMobile) {
      applyDocumentBodyStyle('hidden', 'none');
    } else {
      applyDocumentBodyStyle();
    }

    return () => {
      applyDocumentBodyStyle();
    };
  }, [isEnabled, isMobile]);
};
